import React from "react";
import xLogo from "../assets/social/x.svg";
import linkedinLogo from "../assets/social/linkedin.svg";
import instagramLogo from "../assets/social/instagram.svg";
import facebookLogo from "../assets/social/facebook.svg";
import youtubeLogo from "../assets/social/youtube.svg";
import pinterestLogo from "../assets/social/pinterest.svg";
import whatsappLogo from "../assets/social/whatsapp.svg";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
  FaWhatsapp,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";

const SOCIAL_BRANDS = {
  instagram: { Icon: FaInstagram, color: "#E4405F", label: "Instagram" },
  facebook: { Icon: FaFacebookF, color: "#1877F2", label: "Facebook" },
  linkedin: { Icon: FaLinkedinIn, color: "#0A66C2", label: "LinkedIn" },
  youtube: { Icon: FaYoutube, color: "#FF0000", label: "YouTube" },
  pinterest: { Icon: FaPinterestP, color: "#E60023", label: "Pinterest" },
  whatsapp: { Icon: FaWhatsapp, color: "#25D366", label: "WhatsApp" },
  twitter: { Icon: FaXTwitter, color: "#000000", label: "X" },
  x: { Icon: FaXTwitter, color: "#000000", label: "X" },
};

/** Full-colour logo marks (round badges, YouTube's red shape) as the platforms draw them. */
const LOGO_ASSETS = {
  x: xLogo,
  linkedin: linkedinLogo,
  instagram: instagramLogo,
  facebook: facebookLogo,
  youtube: youtubeLogo,
  pinterest: pinterestLogo,
  whatsapp: whatsappLogo,
};

export function SocialBrandIcon({ platform, className = "w-4 h-4", logo = false, ...props }) {
  const key = String(platform || "").toLowerCase();
  const brand = SOCIAL_BRANDS[key];
  if (!brand) return null;

  const { Icon, color, label } = brand;
  if (logo)
    return (
      <img
        src={LOGO_ASSETS[key === "twitter" ? "x" : key]}
        alt={label}
        className={`social-logo-mark shrink-0 ${className}`}
        draggable={false}
        {...props}
      />
    );
  return <Icon className={className} color={color} aria-label={label} {...props} />;
}

export default SocialBrandIcon;
